export default __webpack_public_path__ + "static/media/login_panel.bf9deb9b.png";